<template>
  <div class="header row no-margin">
    <div class="nav-bar header-logo">
      <div class="float-left" @click="home">
        <img
          v-if="!light_logo || null"
          class="logo"
          :class="showProspectForm ? 'logo-highlight' : ''"
          src="@/assets/logo.svg"
        />
        <img
          v-else
          class="logo"
          :class="showProspectForm ? 'logo-highlight' : ''"
          src="@/assets/img/logo-light.svg"
        />
      </div>
      <div style="display: flex; align-items: center" class="float-right">
        <div
          v-if="pageType === '3' || null"
          class="float-right m-top-13 d-sm-none d-md-block d-none d-sm-block"
        >
          <span v-if="!light_logo || null" class="sign-up"
            ><v-runtime-template :template="createAccountText"
          /></span>
          <span v-else style="color: white" class="sign-up"
            ><v-runtime-template :template="createAccountText"
          /></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import Utils from "@/utils/utilities";
import VRuntimeTemplate from "vue3-runtime-template";
import store from "@/store";
import { useRoute } from "vue-router";

@Component({
  components: {
    VRuntimeTemplate,
  },
})
export default class HeaderLogo extends Vue {
  public showProspectCallbackError = false;
  public prospectCallbackErrorMsg = "";
  public createAccountText = "";
  public createAccountTextTags: any = {
    "app-prospect-menu-create-account-link-1": {
      openTag:
        '<a style="color:white;" @click="home()" href="javascript:void(0)">',
      closeTag: "</a>",
    },
  };

  route = useRoute();
  get path() {
    return this.route.path;
  }

  @Prop({ type: Boolean, required: false, default: false })
  public showProspectForm!: any;

  @Prop({ type: String, required: false, default: "none" })
  public pageType!: any;

  @Prop({ type: Boolean, required: false, default: false })
  public light_logo!: any;

  @Prop({ type: Boolean, required: false, default: true })
  public csrfLoaded!: any;

  @Prop({ type: Boolean, required: false, default: false })
  public languagePicker!: any;

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  @Watch("languageSelected")
  onChangeLanguageSelected() {
    setTimeout(() => {
      if (this.pageType == "3") {
        this.updateUIVariables();
      }
    }, 50);
  }

  mounted() {
    if (this.pageType == "3") {
      this.updateUIVariables();
    }
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  getProcessedUIText(id: string, tags: any) {
    return Utils.getProcessedUIText(
      id,
      tags,
      this.languageSelectedText,
      this.defaultUiText,
    );
  }

  updateUIVariables() {
    this.createAccountText =
      "<span>" +
      this.getProcessedUIText(
        "app-prospect-menu-create-account-1",
        this.createAccountTextTags,
      ) +
      "</span>";
  }

  slideMenu() {
    this.$emit("slideMenu");
  }

  home() {
    this.path !== "/" && this.$router.push("/");
  }
}
</script>
<style lang="scss" scoped>
.right-menu {
  background: rgba(238, 239, 240, 0.3);
  height: 100%;
}

.nav-bar {
  z-index: 1;
}

.logo {
  cursor: pointer;
  z-index: 2;
}

.sign-in a {
  cursor: pointer;
  z-index: 2;
}

.sign-up a {
  cursor: pointer;
  z-index: 2;
}

.log-out a {
  cursor: pointer;
  z-index: 2;
}

@media (max-width: 768px) {
  .mobile-hide {
  }
}
</style>
